
export namespace status {
    export async function getAllStatuses(token: string,host:any) {
      return fetch(host+'/api/status/getAll?token=' + token);
    }
  }
